"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function deepMerge(destination) {
    var e_1, _a;
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    try {
        for (var sources_1 = tslib_1.__values(sources), sources_1_1 = sources_1.next(); !sources_1_1.done; sources_1_1 = sources_1.next()) {
            var source = sources_1_1.value;
            singleMerge(destination, source);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (sources_1_1 && !sources_1_1.done && (_a = sources_1.return)) _a.call(sources_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return destination;
}
exports.deepMerge = deepMerge;
function singleMerge(destination, source, arrayMerge) {
    if (destination === void 0) { destination = {}; }
    if (source === void 0) { source = {}; }
    if (arrayMerge === void 0) { arrayMerge = false; }
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            var dest = destination[key];
            var src = source[key];
            if (Array.isArray(dest)) {
                if (Array.isArray(src)) {
                    destination[key] = arrayMerge ? dest.concat(src) : src;
                }
                else {
                    // 如果目的值是数组，而新的数据为非数组，则使用新数据
                    destination[key] = src;
                }
            }
            else if (destination === null) {
                destination[key] = src;
            }
            else if (typeof dest === "object") {
                singleMerge(destination[key], src);
            }
            else {
                destination[key] = src;
            }
        }
    }
}
//# sourceMappingURL=deep-merge.js.map